import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';

import Navbar from './components/Navbar';
import QRScanner from './components/QRScanner';
import Banner from './components/Banner';
import imgBadge1 from "../images/badge-1.jpg";
import imgBadge2 from "../images/badge-2.jpg";

const ScanSession = () => {

    const [code, setCode] = useState();

    const [selectedSession, setSelectedSession] = useState([]);

    const sessionItems =
        ["Apple Switzerland", "Axis Communications", "Barco", "BenQ Deutschland GmbH", "CONNECT-Academy - KI",
            "Dell Technologies", "EPOS Germany GmbH", "HP Inc", "Huawei", "Jabra", "Lenovo",
            "Microsoft Schweiz GmbH - The Future of Work ", "Microsoft Schweiz GmbH - Windows Server 2025",
            "Mitel Schweiz AG", "NAKIVO", "NVIDIA", "Pax8", "PureLink GmbH", "Schneider Electric Schweiz AG",
            "SCORE! - Carpathia AG", "SCORE! - Competec", "SCORE! - Helion Energy AG", "SCORE! - Meier Tobler",
            "SCORE! - Quatico Solutions AG", "SCORE! - R. Nussbaum AG", "Snom Technology GmbH", "Synology GmbH",
            "TP-Link", "Veeam Software", "Zyxel Networks"]


    let navigate = useNavigate();

    useEffect(() => {
        const storedSession = sessionStorage.getItem("selectedSession");
        if (storedSession) {
            setSelectedSession(storedSession);
        }
    }, []);


    const onSelectSession = (session) => {
        setSelectedSession(session);
        sessionStorage.setItem("selectedSession", session);
    }

    const onClickNavigateToLandingPage = (session) => {
        sessionStorage.removeItem("selectedSession");
        navigate(`/`);
    }

    return (
        <>
            <Navbar />
            <Banner />
            <div className='container mt-4 mb-5 page-container'>
                <div className='row d-flex justify-content-between align-items-center mb-4 ms-2 me-2'>
                    <div className="col-md-6">
                        <h1 className='text text-dark fw-semibold fs-3 mb-0'>Lead erfassen</h1>
                    </div>
                    <div className="col-md-6 text-end">
                        <button
                            className='nav-btn'
                            style={{ backgroundColor: 'transparent' }}
                            onClick={() => onClickNavigateToLandingPage()}
                        >
                            back
                        </button>
                    </div>
                </div>
                <div className='content m-3'>
                    {selectedSession !== "" &&
                        <h3 className='text text-dark fw-semibold fs-3 mb-3'>Session Check-In <br /> {selectedSession}</h3>
                    }

                    <p className='text text-secondary fs-6'>
                        Scannen Sie den QR-Code auf dem Namensschild des Kunden, indem Sie auf den untenstehenden Button tippen.
                    </p>

                    {/* <a className='scan-link' href="intent://camera/#Intent;end">Android: QR-Codeleser herunterladen</a> <br></br>
                          <a className='scan-link' href="photos-redirect://">iOS: QR-Scanner herunterladen</a>  <br></br> <br></br>
                          <a className='scan-link' href="/contact/609757863771">Contact Formular</a> */}

                    <div className='mb-3'>
                        <QRScanner isSessionCheckin={true} />
                    </div>

                    <p className='text text-secondary fs-6'>
                        Wenn der Scan auf Ihrem Gerät nicht funktioniert, können Sie die Ticketnummer eingeben, welche oberhalb des QR-Codes auf dem Namensschild des Kunden abgedruckt ist.
                    </p>

                    <div className="input-group mb-3">
                        <input type="number" className="form-control continue-input" pattern={[0 - 9]} placeholder="Ticketnummer eingeben" aria-label="Recipient's username" aria-describedby="basic-addon2" onChange={(e) => setCode(e.currentTarget.value)} value={code} />
                        <div className="input-group-append">
                            <button className='btn continue-btn ps-4 pe-4' onClick={() => navigate(`/session-checkin/${code}`)}>Senden</button>
                        </div>
                    </div>
                </div>

                <div className='content m-3'>
                    <h3 className='text text-dark fw-semibold fs-3 mb-3'>Hilfebereich</h3>

                    <p className='text text-dark fs-6 fw-bold mb-1'>
                        Wo finden Sie die Ticketnummer?
                    </p>

                    <p className='text text-secondary fs-6 mb-2'>
                        Falls der QR-Scan bei Ihnen nicht funktioniert: Die Ticketnummer ist neben dem QRCode auf dem Namensschild aufgedruckt.
                    </p>

                    <img className='img-fluid mb-3' src={imgBadge1}></img>

                    <p className='text text-dark fs-6 fw-bold mb-1'>
                        Der Kunde hat kein Namensschild
                    </p>

                    <p className='text text-secondary fs-6 mb-2'>
                        Wenn der Kunde sein Namensschild nicht zur Hand hat, kann auch der QR-Code auf dem Eintrittsticket gescannt werden, welches dem Kunden per Mail zugestellt wurde.
                    </p>

                    <img className='img-fluid mb-3' src={imgBadge2}></img>

                    <p className='text text-dark fs-6 fw-bold mb-1'>
                        Detaillierter Leitfaden
                    </p>

                    <p className='text text-secondary fs-6 mb-2'>
                        Benötigen Sie weitere Unterstützung? Den detaillierten Leitfaden zur Leadlösung finden Sie auf unserer Website:
                    </p>

                    <a href='https://connect-fachmesse.ch/Handouts-Anleitungen/' target='blank'>https://connect-fachmesse.ch/Handouts-Anleitungen/</a>
                </div>
            </div>
        </>
    )
}

export default ScanSession